import Hero from 'Nori/Hero/HeroFull2';
import Layout from 'Nori/Layout';

import { Finder } from 'Custom/Finder';
import { Pregnancies } from 'Custom/Pregnancies';

import styles from 'styles/pages/birthControlOptions.module.scss';

import HERO_BG_IMAGE from 'Images/background/half-pink-marble.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/pink-mobile-banner.png';

import HeroQuestion from 'Custom/HeroQuestion/index';
import Container from 'Nori/Container/index';

const HEAD = {
  title: 'Understanding Available Birth Control Options',
  description:
    'Learn about different birth control options, including NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, discuss with your doctor which option may be right for you.',
  keywords:
    'Birth Control Options, Arm Implant Birth Control Options, Compare Birth Control Methods',
};

export default function Home() {
  return (
    <Layout head={HEAD}>
      <Hero
        image={HERO_BG_IMAGE}
        mobileImage={HERO_BG_IMAGE_MOBILE}
        className={styles.heroBirthControlOpt}
        data-qa-tag="heror birth control options"
      >
        <Container>
          <h4 className={styles.heroBaseHeading} data-qa-tag="heroBaseHeading">
            UNDERSTANDING BIRTH CONTROL
          </h4>
          <div className={styles.heroHeading}>
            <div className={styles.middleHeroText} data-qa-tag="middleHeroText">
              i&rsquo;m currently on <span>Nexplanon</span>, <br />
              but what are my other options?
            </div>
          </div>
          <div className={styles.heroSubheading} data-qa-tag="heroSubheading">
            Talk with your doctor about the birth control options that are right
            for you.
          </div>
        </Container>
      </Hero>

      <Pregnancies
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="what are some birth control options?"
        data-design-module_no="02"
        data-qa-tag="what are some birth control options?"
      />

      <Finder data-design-module_no="03" />
      <HeroQuestion></HeroQuestion>
    </Layout>
  );
}
